import React from 'react';
import { InfoAlert } from 'smartsuite-ui';

export default function DeletedBagMessage() {
    return (
        <InfoAlert>
            <div>
                <div>
                    <b>This bag tag was deleted </b>
                </div>
                <div>
                    It is possible that the tag was printed by mistake or that
                    there were two tags for the same bag
                </div>
            </div>
        </InfoAlert>
    );
}
